export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const RETRIEVE_USERS = "RETRIEVE_USERS";
export const RETRIEVE_LOGGEDIN_USER = "RETRIEVE_LOGGEDIN_USER";
export const CREATE_USER = "UPDATE_USER";
export const UPDATE_USER = "CREATE_USER";
export const DELETE_USER = "DELETE USER";
export const RESTORE_USER = "RESTORE_USER";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const VERIFY_TAX_INFO = "VERIFY_TAX_INFO";

export const RETRIEVE_STATES = "RETRIEVE_STATES";
export const RETRIEVE_CITIES = "RETRIEVE_CITIES";
export const CREATE_CITY = "CREATE_CITY";
export const UPDATE_CITY = "UPDATE_CITY";
export const DELETE_CITY = "DELETE_CITY";
export const RESTORE_CITY = "RESTORE_CITY";
export const UPDATE_CITY_STATUS = "UPDATE_CITY_STATUS";

export const RETRIEVE_SPACES = "RETRIEVE_SPACES";
export const UPDATE_SPACE_STATUS = "UPDATE_SPACE_STATUS";
export const UPDATE_IS_ACTIVE = "UPDATE_IS_ACTIVE";
export const DELETE_SPACE = "DELETE_SPACE";
export const RESTORE_SPACE = "RESTORE_SPACE";
export const UPDATE_SPACE_SEARCHABLE_STATUS = "UPDATE_SPACE_SEARCHABLE_STATUS";
export const UPDATE_SPACE_CLAIM_LISTING_STATUS = "UPDATE_SPACE_CLAIM_LISTING_STATUS";
export const UPDATE_SPACE_IS_AVAILABLE = "UPDATE_SPACE_IS_AVAILABLE";

export const SHOW_IMAGE_BACKDROP = "SHOW_IMAGE_BACKDROP";
export const CLOSE_IMAGE_BACKDROP = "CLOSE_IMAGE_BACKDROP";
export const SHOW_VIDEO_BACKDROP = "SHOW_VIDEO_BACKDROP";
export const CLOSE_VIDEO_BACKDROP = "CLOSE_VIDEO_BACKDROP";

export const RETRIEVE_PAGES = "RETRIEVE_PAGES";
export const CREATE_PAGE = "CREATE_PAGE";
export const UPDATE_PAGE = "UPDATE_PAGE";
export const DELETE_PAGE = "DELETE_PAGE";
export const RESTORE_PAGE = "RESTORE_PAGE";
export const UPDATE_PAGE_STATUS = "UPDATE_PAGE_STATUS";

export const RETRIEVE_STORAGE_TYPES = "RETRIEVE_STORAGE_TYPES";
export const CREATE_STORAGE_TYPE = "CREATE_STORAGE_TYPE";
export const UPDATE_STORAGE_TYPE = "UPDATE_STORAGE_TYPE";
export const DELETE_STORAGE_TYPE = "DELETE_STORAGE_TYPE";
export const RESTORE_STORAGE_TYPE = "RESTORE_STORAGE_TYPE";
export const UPDATE_STORAGE_TYPE_STATUS = "UPDATE_STORAGE_TYPE_STATUS";

export const RETRIEVE_PROMO_CODES = "RETRIEVE_PROMO_CODES";
export const CREATE_PROMO_CODE = "CREATE_PROMO_CODE";
export const UPDATE_PROMO_CODE = "UPDATE_PROMO_CODE";
export const DELETE_PROMO_CODE = "DELETE_PROMO_CODE";
export const RESTORE_PROMO_CODE = "RESTORE_PROMO_CODE";
export const UPDATE_PROMO_CODE_STATUS = "UPDATE_PROMO_CODE_STATUS";

export const RETRIEVE_VEHICLE_TYPES = "RETRIEVE_VEHICLE_TYPES";
export const CREATE_VEHICLE_TYPE = "CREATE_VEHICLE_TYPE";
export const UPDATE_VEHICLE_TYPE = "UPDATE_VEHICLE_TYPE";
export const DELETE_VEHICLE_TYPE = "DELETE_VEHICLE_TYPE";
export const RESTORE_VEHICLE_TYPE = "RESTORE_VEHICLE_TYPE";
export const UPDATE_VEHICLE_TYPE_STATUS = "UPDATE_VEHICLE_TYPE_STATUS";

export const RETRIEVE_STORAGE_CATEGORIES = "RETRIEVE_STORAGE_CATEGORIES";
export const UPDATE_STORAGE_CATEGORY = "UPDATE_STORAGE_CATEGORY";

export const RETRIEVE_STORAGE_ITEMS = "RETRIEVE_STORAGE_ITEMS";
export const CREATE_STORAGE_ITEM = "CREATE_STORAGE_ITEM";
export const UPDATE_STORAGE_ITEM = "UPDATE_STORAGE_ITEM";
export const DELETE_STORAGE_ITEM = "DELETE_STORAGE_ITEM";
export const RESTORE_STORAGE_ITEM = "RESTORE_STORAGE_ITEM";
export const UPDATE_STORAGE_ITEM_STATUS = "UPDATE_STORAGE_ITEM_STATUS";

export const RETRIEVE_SOURCES = "RETRIEVE_SOURCES";
export const CREATE_SOURCE = "CREATE_SOURCE";
export const UPDATE_SOURCE = "UPDATE_SOURCE";
export const DELETE_SOURCE = "DELETE_SOURCE";
export const RESTORE_SOURCE = "RESTORE_SOURCE";

export const RETRIEVE_REVIEWS = "RETRIEVE_REVIEWS";
export const CREATE_REVIEW = "CREATE_REVIEW";
export const UPDATE_REVIEW = "UPDATE_REVIEW";
export const DELETE_REVIEW = "DELETE_REVIEW";
export const RESTORE_REVIEW = "RESTORE_REVIEW";
export const UPDATE_REVIEW_STATUS = "UPDATE_REVIEW_STATUS";

export const RETRIEVE_RESERVATIONS = "RETRIEVE_RESERVATIONS";
export const RETRIEVE_RESERVATIONS_BY_USER = "RETRIEVE_RESERVATIONS_BY_USER";
export const UPDATE_RESERVATION_STATUS = "UPDATE_RESERVATION_STATUS";
export const UPDATE_RESERVATION_PAYMENT_STATUS = "UPDATE_RESERVATION_PAYMENT_STATUS";
export const UPDATE_PAYOUT_HOLD_STATUS = "UPDATE_PAYOUT_HOLD_STATUS";

export const RETRIEVE_TRANSACTIONS = "RETRIEVE_TRANSACTIONS";
export const RETRIEVE_RENTER_TRANSACTIONS = "RETRIEVE_RENTER_TRANSACTIONS";
export const REFUND_AMOUNT = "REFUND AMOUNT";

export const RETRIEVE_REWARD_POINTS_TRANSACTION = "RETRIEVE_REWARD_POINTS_TRANSACTION";
export const VIEW_REWARD_POINTS_TRANSACTION = "VIEW_REWARD_POINTS_TRANSACTION";
export const CREATE_REWARD_POINTS_TRANSACTION = "CREATE_REWARD_POINTS_TRANSACTION";
export const UPDATE_REWARD_POINTS_TRANSACTION = "UPDATE_REWARD_POINTS_TRANSACTION";
export const DELETE_REWARD_POINTS_TRANSACTION = "DELETE_REWARD_POINTS_TRANSACTION";
export const RESTORE_REWARD_POINTS_TRANSACTION = "RESTORE_REWARD_POINTS_TRANSACTION";
export const UPDATE_REWARD_POINTS_TRANSACTION_STATUS = "UPDATE_REWARD_POINTS_TRANSACTION_STATUS";



export const RETRIEVE_REFUNDS = "RETRIEVE_REFUNDS";

export const RETRIEVE_PAYOUTS = "RETRIEVE_PAYOUTS";
export const RETRIEVE_HOST_PAYOUTS = "RETRIEVE_HOST_PAYOUTS";

export const RETRIEVE_FAQ = "RETRIEVE_FAQ";
export const CREATE_FAQ = "CREATE_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";
export const RESTORE_FAQ = "RESTORE_FAQ";
export const UPDATE_FAQ_STATUS = "UPDATE_FAQ_STATUS";

export const UPDATE_SETTINGS = "UPDATE_SETTINGS";

export const UPDATE_BECOME_A_HOST = "UPDATE_BECOME_A_HOST";

export const RETRIEVE_HOST_REPORT = "RETRIEVE_HOST_REPORT";
export const RETRIEVE_RENTER_REPORT = "RETRIEVE_RENTER_REPORT";
export const RETRIEVE_RESERVATION_REPORT = "RETRIEVE_RESERVATION_REPORT";
export const RETREIVE_DRAFT_LISTING = "RETREIVE_DRAFT_LISTING";

export const RETRIEVE_DYNAMICMETADATAS = "RETRIEVE_DYNAMICMETADATAS";
export const CREATE_DYNAMICMETADATA = "CREATE_DYNAMICMETADATA";
export const UPDATE_DYNAMICMETADATA = "UPDATE_DYNAMICMETADATA";
export const DELETE_DYNAMICMETADATA = "DELETE_DYNAMICMETADATA";
export const RESTORE_DYNAMICMETADATA = "RESTORE_DYNAMICMETADATA";
export const UPDATE_DYNAMICMETADATA_STATUS = "UPDATE_DYNAMICMETADATA_STATUS";
export const UPDATE_PROMO_SENT_STATUS = "UPDATE_PROMO_SENT_STATUS";
export const SEND_ACCESS_INFO = "SEND_ACCESS_INFO";
export const RETRIEVE_BLOCKED_IP_ADDRESSES = "RETRIEVE_BLOCKED_IP_ADDRESSES";
export const CREATE_BLOCKED_IP_ADDRESS = "CREATE_BLOCKED_IP_ADDRESS";
export const UNBLOCK_IP_ADDRESS = "UNBLOCK_IP_ADDRESS";
export const DELETE_BLOCKED_IP_ADDRESS = "DELETE_BLOCKED_IP_ADDRESS";